/**
 * @param {import('axios').AxiosInstance} apiClient
 * @param {object} body — vault_uuid, parent_folder_uuid, pagination, etc.
 */
export const listFoldersByTenant = async (apiClient, body) => {
  return apiClient.post('/v1/tenant/folder/list', body);
};
